<template>
  <div>
    <h3>{{ row.title }}—{{ row.mapping }}</h3>
    <Tree
      ref="tree"
      :data="authData"
      show-checkbox
      multiple
      check-directly
      @on-check-change="checkTree"
      @on-select-change="checkTree"
      class="auth-tree"
    >
    </Tree>
  </div>
</template>

<script>
import { getRoleAuth } from "@/api/system/role";
export default {
  props: {
    row: {
      type: Object
    },
    close: {
      type: Function
    }
  },
  data() {
    return {
      authData: []
    };
  },
  mounted() {
    console.log(this.row);
    getRoleAuth({ role_id: this.row.id }).then(res => {
      this.authData = res.data.payload;
    });
  },
  methods: {
    handClick() {
      return this.$refs["tree"].getCheckedAndIndeterminateNodes();
    },
    checkTree(e, val) {
      let arr = this.treeToArr(this.authData);
      let parent = null;
      let isFirst = true;
      arr.map(item => {
        if (!val.checked && val.tag == "view") {
          if (item.children && item.children.length > 0 && item.pid === 0) {
            parent = item;
          }
          if (item.id == val.pid && isFirst) {
            item.indeterminate = false;
            if (item.pid == parent.id) {
              parent.indeterminate = false;
            }
          }
          if (item.pid == val.pid) {
            item.checked = false;
          }
        } else {
          if (item.pid == val.pid && item.tag == "view" && val.checked) {
            item.checked = true;
          }
        }
      });
    },
    treeToArr(tree) {
      let arr = [];
      const expanded = datas => {
        if (datas && datas.length > 0) {
          datas.forEach(e => {
            arr.push(e);
            expanded(e.children);
          });
        }
      };
      expanded(tree);
      return arr;
    }
  }
};
</script>

<style>
.auth-tree {
  height: 600px;
  overflow: auto;
}
.footer-div {
  border-top: 1px solid #e8eaec;
  margin: 0 -16px;
}
</style>
